import $ from 'jquery';
import carousel from 'owl.carousel';

$(() => {
	$('.servise-slider').owlCarousel({
		loop:false,
		margin:20,
		responsive:{
			0: {
				items: 1
			},
			350: {
				items: 1,
				stagePadding: 60
			},
			430: {
				items: 1,
				stagePadding: 100
			},
			481: {
				items:1,
				stagePadding: 60
			},
			600: {
				items:2,
				stagePadding: 30
			},
			680: {
				items:2,
				stagePadding: 60
			},
			768: {
				items: 2,
				stagePadding: 120
			},
			1000: {
				items: 3,
				stagePadding: 120
			},
			1500:{
				items:4,
				stagePadding: 120
			}
		}
	})
	$('.partners__items').owlCarousel({
		responsive:{
			0:{
				items: 2,
				margin: 40
			},
			400:{
				items: 3,
				margin: 40
			},
			600: {
				items: 4,
				margin: 50
			},
			1000: {
				items: 5,
				margin: 100
			}
		}
	})


	$('.open-modal').magnificPopup({
		items: {
			src: ".popup",
			type: "inline"
		},
		removalDelay: 100,
		showCloseBtn: false,
		callbacks: {
			beforeOpen: function () {
				var magnificPopup = $.magnificPopup.instance
				var header = $(magnificPopup.st.el).attr("data-header");
				var input_type = $(magnificPopup.st.el).attr("data-input_type");
				var btn_text = $(magnificPopup.st.el).attr("data-btn_text");
				$(".popup__title").html(header);
				$(".popup .form__input").hide();
				$(".popup .form__input input[type='" + input_type + "']").parent().show();
				$(".popup .form__button .button").html(btn_text);
			}
		}
	});


	$(".popup__close").click(function () {
		$.magnificPopup.close();
	});

	$(document).ready(function () {
		ymaps.ready(init);
		function init() {
			var geocoder = new ymaps.geocode(
			// Строка с адресом, который нужно геокодировать
			'Москва, ул.Павелецкая набережная, 2',
			// требуемое количество результатов
			{ results: 1 });
			// После того, как поиск вернул результат, вызывается callback-функция
			geocoder.then(function (res) {
				// координаты объекта
				var coord = res.geoObjects.get(0).geometry.getCoordinates();
				var map = new ymaps.Map('map', {
					// Центр карты - координаты первого элемента
					center: coord,
					// Коэффициент масштабирования
					zoom: 14,
					scroll: false
				});
				// Добавление метки на карту
				map.geoObjects.add(res.geoObjects.get(0));
				map.behaviors.disable('scrollZoom');
			});
		}

		$(".menu__first a").hover(function () {
			var visible_index = $(this).closest(".menu").find(".dropdown-list ul:visible").index();
			var current_index = $(this).closest("li").index();
			if (visible_index != current_index) {
				$(this).closest(".menu").find(".dropdown-list ul").fadeOut();
				$(this).closest(".menu").find(".dropdown-list ul").eq(current_index).fadeIn();
			}	
		});
		$(".menu .dropdown-list ul").mouseleave(function (e) {
			$(this).hide();
		});

		$(".menu").stellarNav({
			breakpoint: 480
		});
	});

	$(".header__bars-mobile").click(function () {
		$(".header__menu").slideToggle(function () {
			if ($(".header__menu").is(":visible")) {
				$(".header__bars-mobile img").hide();
				$(".header__bars-mobile").append("<span>X</span>");
			}
			else {
				$(".header__bars-mobile span").remove();
				$(".header__bars-mobile img").show();
			}
		});
	});

	
});




// WEBPACK FOOTER //
// ./app/scripts/app.js